import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface CleanUpDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CleanUpDescription: React.FC<CleanUpDescriptionProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [cleanUp, set_cleanUp] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Final Structure']?.['Clean Up']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Final Structure': { ...b.values?.['Final Structure'], 'Clean Up': [v, b.values?.['Final Structure']?.['Clean Up']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={cleanUp}
                />
            ) : (
                <TextBox
                    value={cleanUp}
                    onChange={(value) => set_cleanUp(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
